// extracted by mini-css-extract-plugin
module.exports = {"root":"ReportModalFilter_root__1USsI","footer":"ReportModalFilter_footer__RItz4"};